import { SkeletonPage } from '@shopify/polaris';
import { memo } from 'react';
import SkeletonLayout from '../SkeletonLayout';

function BaseSkeletonPage({ elementCount = 3 }) {
  return (
    <SkeletonPage>
      <SkeletonLayout elementCount={elementCount} />
    </SkeletonPage>
  );
}

export default memo(BaseSkeletonPage);
